import { join } from 'path';
import { homedir } from 'os';

const SMARTSTACK_DIR = '.smartstack';

/** ~/.smartstack/ directory */
export function getSmartStackDir(): string {
  return join(homedir(), SMARTSTACK_DIR);
}

/** ~/.smartstack/license.key */
export function getLicenseFilePath(): string {
  return join(getSmartStackDir(), 'license.key');
}

/** ~/.smartstack/license-cache.json */
export function getLicenseCachePath(): string {
  return join(getSmartStackDir(), 'license-cache.json');
}

/** ~/.smartstack/device.json */
export function getDeviceFilePath(): string {
  return join(getSmartStackDir(), 'device.json');
}

/** ~/.smartstack/api-key */
export function getApiKeyFilePath(): string {
  return join(getSmartStackDir(), 'api-key');
}

/** ~/.smartstack/config.json */
export function getConfigFilePath(): string {
  return join(getSmartStackDir(), 'config.json');
}
